import { useCallback } from 'react';

import * as events from 'src/lib/events';
import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';
import { useTrackingEvent } from 'src/services/useTrackingEvent';

import { ImageStylePopup } from './ImageStylePopup';

const POPUP_KEY = Symbol('IMAGE_STYLE');

export const useImageStylePopup = () => {
  const popups = usePopups();
  const trackEvent = useTrackingEvent();

  useEffectOnce(() => {
    popups.registerPopup(POPUP_KEY, ImageStylePopup);
  });

  /**
   * Open the "Image Style" popup, either for creating a new style or editing an existing one.
   *
   * @param {Object} visualLanguage - "visual language" to create image style for
   * @param {Object} [imageStyle] - image style to edit (optional)
   * @returns {Promise<Object>} - created or updated image style object
   */
  return useCallback(
    ({ visualLanguage, imageStyle = null }) => {
      return new Promise((resolve) => {
        trackEvent(events.IMAGE_STYLE.popupShown, {
          page: events.EVENT_PAGE.imageStyle,
        });

        popups.openPopup(POPUP_KEY, {
          visualLanguage,
          imageStyle,

          onClose: (result) => {
            popups.closePopup(POPUP_KEY);
            resolve(result);
          },
        });
      });
    },
    [popups, trackEvent]
  );
};
